export default function () {
    var scope = $("[data-price-calculator]");

    if (!scope)
        return;

    var priceGrossBox = scope.find("[data-gross-price]");
    var priceBox = scope.find("[data-net-price]");
    var taxRateBox = scope.find("[data-tax-rate]");
    var taxRate = parseInt(taxRateBox.val());

    taxRateBox.on("change", function () {
        taxRate = parseInt(taxRateBox.val());
        priceBox.trigger("keyup");
    });

    priceGrossBox.on("blur", function () {
        priceBox.trigger("keyup");
    });

    priceGrossBox.on("keyup", function () {
        var grossPrice = parseFloat($(this).val().replace(",", ".")) || 0;
        var netto = (grossPrice / (1 + ((taxRate) / 100))).toFixed(3);

        priceBox.val(netto.replace(".", ","));
    });

    priceBox.on("keyup", function () {
        var price = parseFloat($(this).val().replace(",", ".")) || 0;
        var grossPrice = (price + ((price * taxRate) / 100)).toFixed(2);

        priceGrossBox.val(grossPrice.replace(".", ","));
    });
}